import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TabController } from '@one-thd/sui-atomic-components';
import PianoTabContext from './PianoContext';

const PianoProvider = ({ children }) => {
  const [keyValue, setKeyValue] = useState(0);
  const [keyLabel, setKeyLabel] = useState('');

  const onTabChange = (keyIndex, label) => {
    setKeyValue(keyIndex);
    setKeyLabel(label);
  };

  const ctx = {
    keyLabel,
    keyValue,
    onTabChange
  };

  return (
    <div
      data-testid="piano-pod"
      className="sui-grid sui-w-full sui-h-full"
      style={{ 
        gridTemplateRows: '1fr auto',
        gridTemplateColumns: '1fr'
      }}
    >
      <PianoTabContext.Provider value={ctx}>
        <TabController data-testid="piano-pod" value={keyValue}>
          {children}
        </TabController>
      </PianoTabContext.Provider>
    </div>
  );
};

PianoProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default PianoProvider;
